import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, Lock } from 'lucide-react';
import { Button, useToast } from '../components/ui';
import { useLoginMutation } from '../store/customersApi';

export default function Login() {
  const navigate = useNavigate();
  const toast = useToast();
  const [login, { isLoading }] = useLoginMutation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login({ email, password }).unwrap();
      navigate('/mi-cuenta');
    } catch (e: any) {
      toast.error({ title: 'No se pudo iniciar sesión', description: e?.data?.message ?? 'Revisá tus datos e intentá de nuevo.' });
    }
  };

  const inputClass = 'w-full bg-slate-50 border border-slate-200 focus:border-indigo-500/50 focus:bg-white rounded-xl pl-10 pr-4 py-2.5 text-sm text-slate-800 placeholder-slate-400 focus:outline-none transition-colors';

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <form onSubmit={handleSubmit} className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl shadow-sm p-8 space-y-4">
        <h1 className="font-heading font-extrabold text-2xl text-slate-900 text-center mb-2">Iniciar sesión</h1>

        <div className="relative">
          <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} />
          <Mail className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
        </div>
        <div className="relative">
          <input required type="password" placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} />
          <Lock className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
        </div>

        <p className="text-right -mt-1">
          <Link to="/olvide-mi-contrasena" className="text-xs text-indigo-600 font-semibold hover:underline">¿Olvidaste tu contraseña?</Link>
        </p>

        <Button type="submit" variant="primary" size="lg" loading={isLoading} className="w-full">
          Iniciar sesión
        </Button>

        <p className="text-xs text-slate-500 text-center pt-2">
          ¿No tenés cuenta? <Link to="/registro" className="text-indigo-600 font-semibold hover:underline">Registrate</Link>
        </p>
      </form>
    </div>
  );
}
